import React, { useEffect } from "react";
import { Conteiner } from './style';
import firebase from 'firebase/app';
import 'firebase/database';
import { useFirebase } from '../../hooks/Firebase';
import { ReactionData } from "./reaction.model";



interface ReactionsCount {
    'like': number,
    'heart': number,
    'surprised': number,
    'haha': number,
    'total': number
}
type ReactionType = "haha" | "surprised" | "heart" | "like";

let reactionValue: ReactionType = 'haha'
let userData: { eventId: string, id: string } = JSON.parse(localStorage.getItem('@Storage:user') || '{"eventId":"","id":""}');


const firestore = firebase.firestore();
const listReactions: ReactionData[] = [];
let locked = false 
let reactionsCount: ReactionsCount = {
    'like': 0,
    'heart': 0,
    'surprised': 0,
    'haha': 0,
    'total': 0
}



interface ReactionBarProps {
    onValueChange: (value: string) => void;
    primary?: string;
    secondary?: string;
    accent?: string;
}

const ReactionBar: React.FC<ReactionBarProps> = ({ onValueChange, primary, secondary, accent }) => {
    const { database } = useFirebase();
    const dbRef = database.ref(`videoReactions/${userData.eventId}/reactions`)
    useEffect(() => {
        firestore.collection(`videoReactions/${userData.eventId}/totalReactions`).doc(userData.eventId)
        .onSnapshot((value) => {
            const data = value.data() as ReactionsCount
            if(data){
                reactionsCount = data
            }
        })
        
        // dbRef.on('value', (value) => {
        //     const data = value.val() as { [key: string]: ReactionData }
        // })
     }, []) 

    const TheBounce = () => {
        if (locked) return
        locked = true
        setTimeout(() => {
            locked = false
            
            // Gravar reações no Realtime Database
            if (listReactions.length > 0) {
                const reactionsRef = dbRef;
                
                // Criar um batch de reações para enviar
                const batchReactions: { [key: string]: ReactionData } = {};
                
                listReactions.forEach((reaction, index) => {
                    // Gera uma chave única para cada reação
                    const reactionKey = reactionsRef.push().key;
                    if (reactionKey) {
                        batchReactions[reactionKey] = reaction;
                    }
                });
                
                // Atualizar todas as reações de uma vez
                reactionsRef.update(batchReactions)
                    .then(() => {
                       
                        firestore.collection(`videoReactions/${userData.eventId}/totalReactions`)
                        .doc(userData.eventId)
                        .set(reactionsCount)
                        .then(() => {
                            listReactions.length = 0;
                        })
                    })
                    .catch((error) => {
                        console.error('Erro ao gravar reações:', error);
                    });
            }
            
            
            
        
        }, 1000)
    };

    const valueEmitter = (reactionType: ReactionType, id_reaction: string) => {
        onValueChange(reactionType)
        reactionsCount[reactionType] = reactionsCount[reactionType] + 1
        reactionsCount['total'] = reactionsCount['total'] + 1
        const reactions = {
            id_reaction: id_reaction,
            id_event: userData.eventId,
            id_user: userData.id,
            timestamp: new Date().toISOString(),
            reactionType: reactionType,
        }
        if (listReactions.length > 15) {
            listReactions.shift()
        }
        listReactions.push(reactions)
        TheBounce()


    };

    const handleClick = (e: React.MouseEvent<HTMLImageElement>, reactionType: ReactionType, id_reaction: string) => {
        const target = e.currentTarget;
        // Reinicia a animação caso o usuário clique rápido várias vezes
        target.classList.remove('clicked');
        // força reflow para reiniciar o keyframe
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        target.offsetWidth;
        target.classList.add('clicked');
        setTimeout(() => target.classList.remove('clicked'), 500);
        valueEmitter(reactionType, id_reaction);
    };


    return (
        <Conteiner primary={primary} secondary={secondary} accent={accent}>
            <div className="likes">
            <img className="icon-like" src="/assets/images/reactions/Like-alt.svg" />
                <span className="count-like"> {reactionsCount.total}</span>
            </div>
            <div className="reactions">
                <img onClick={(e) => handleClick(e, 'like', '1')} src="/assets/images/reactions/like.png" />
                <img onClick={(e) => handleClick(e, 'heart', '2')} src="/assets/images/reactions/heart.png" />
                <img onClick={(e) => handleClick(e, 'haha', '3')} src="/assets/images/reactions/haha.png" />
                <img onClick={(e) => handleClick(e, 'surprised', '4')} src="/assets/images/reactions/surprised.png" />
            </div>
        </Conteiner>

    )
}
export default ReactionBar;